<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示</div>
      <div class="tips-details">
        <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
        <div class="no">
          2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
        </div>
        <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
        <div class="no">
          4.域见未来单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
        </div>  
      </div>
    </div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">发票类型：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="searchObj.invoiceType"
            style="width: 200px"
            clearable
          >
            <Option
              v-for="item in invoiceTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 30px;">
          <div class="name" style="margin-right: 10px">开具类型：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="searchObj.issueType"
            style="width: 200px"
            clearable
          >
            <Option
              v-for="item in issueTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="searchObj.title"
            placeholder="请输入发票抬头"
            style="width: 280px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
          <Button class="bj-search-btn-F85A36" type="primary" @click="onAdd">添加发票信息</Button>
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total bj-rows content-start">
        <div>搜索结果<span class="count">（{{ searchObj.total }}）</span></div>
      </div>
      <Table
        class="bj-2F3033-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="invoiceType" slot-scope="{ row }">
          <span>{{ row.tt | invoiceTypeFilter }}</span>
        </template>
        <template slot="issueType" slot-scope="{ row }">
          <span>{{ row.t | issueTypeFilter }}</span>
        </template>
        <template slot="op" slot-scope="{ row }">
          <div class="table-btn" @click="onUpdate(row.id)">编辑</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          onPageSizeChange
        />
      </div>
    </div>
    <addInvoiceModal
      :show.sync="addInvoiceModalVisibility"
      :type="addInvoiceModalType"
      :id="addInvoiceModalId"
      @submit-success="onSuccess"
    ></addInvoiceModal>
  </div>
</template>

<script>
import { invoiceCancel, invoiceInfoList } from "api/user.js";
import addInvoiceModal from "components/invoice/addInvoiceModal.vue";
export default {
  name: "invoice",
  components: {
    addInvoiceModal,
  },
  filters: {
    invoiceTypeFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "增值税普通发票";
          break;
        case 1:
          title = "增值税专用发票";
          break;
      }
      return title;
    },
    issueTypeFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "个人";
          break;
        case 1:
          title = "企业";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      invoiceTypeList: [
        {
          label: "增值税普通发票",
          value: 0,
        },
        {
          label: "增值税专用发票",
          value: 1,
        },
      ],
      issueTypeList: [
        {
          label: "个人",
          value: 0,
        },
        {
          label: "类型",
          value: 1,
        },
      ],
      searchObj: {
        issueType: null,
        invoiceType: null,
        title: "",
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          title: "发票抬头",
          key: "header",
          align: "center",
        },
        {
          title: "开具类型",
          slot: "invoiceType",
          align: "center",
        },
        {
          title: "发票类型",
          slot: "issueType",
          align: "center",
        },
        {
          title: "操作",
          ellipsis: true,
          slot: "op",
          align: "center",
        },
      ],
      data: [],
      tableLoading: false,
      addInvoiceModalVisibility: false,
      addInvoiceModalType: 0,
      addInvoiceModalId: "",
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          header: this.searchObj.title,
        };
        this.searchObj.issueType !== -1 &&
          (params.t = this.searchObj.issueType);
        this.searchObj.invoiceType !== -1 &&
          (params.tt = this.searchObj.invoiceType);
        this.tableLoading = true;
        const { code, data } = await invoiceInfoList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    handleChange(val) {
      this.searchObj.startAtStr = val;
    },
    // 取消申请
    cancelInvoiceEvent(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消申请此发票吗？</p>",
        onOk: async () => {
          let res = await invoiceCancel({ id });
          res = res.data;
          if (res.code === 200) {
            this.$Message.success("取消成功！");
            this.onPageChange(1);
          }
        },
      });
    },
    // 去详情页面
    onUpdate(id) {
      this.addInvoiceModalVisibility = true;
      this.addInvoiceModalType = 2;
      this.addInvoiceModalId = id;
    },
    // 添加
    onAdd() {
      this.addInvoiceModalVisibility = true;
      this.addInvoiceModalType = 1;
      this.addInvoiceModalId = "";
    },
    // 添加成功
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
.tips-section {
  background-color: #28292C;
  border-radius: 6px;
  display: flex;
  margin-top: 20px;
  .title {
    width: 80px;
    height: 160px;
    color: #fff;
    font-size: 16px;
    background-color: #4E312D;
    padding: 30px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .tips-details{
    padding: 28px 23px 10px;
    .no {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
    }
  }
  
}
.bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    margin-top: 30px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>
